export default __webpack_public_path__ + "static/media/working.1a5b2486.svg";